const PageNotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen group disabled:text-stone-light text-white ">
      <h1 className="text-6xl font-semibold">404</h1>
      <p className="mt-4 text-xl">Page Not Found</p>
      <p className="mt-2">The page you are looking for does not exist.</p>
    </div>
  );
}

export default PageNotFound;